import {ALL_FIBER, BigCoverMapRegions, FiberCoverMapRegions, isSameRegion, MapRegion, MapTechnology} from "./CoverageMap.ts";

export default function CoverageChoiceComponent(props: {
    fiberMapOnly: boolean,
    static: boolean
    activeRegion: MapRegion
    setActiveRegion: (region: MapRegion) => void
}) {
    return (
        <>
            {!props.fiberMapOnly && !props.static && (
                <div className="coverage-buttons coverage-buttons-primary">
                    <p>Vælg bredbåndsteknologi:</p>
                    <CoverMapChoiceButton
                        mapRegion={BigCoverMapRegions.FIBER}
                        activeRegion={props.activeRegion}
                        setActiveRegion={props.setActiveRegion}
                    />
                    <CoverMapChoiceButton
                        mapRegion={BigCoverMapRegions.MBB}
                        activeRegion={props.activeRegion}
                        setActiveRegion={props.setActiveRegion}
                    />
                    <CoverMapChoiceButton
                        mapRegion={BigCoverMapRegions.COAX}
                        activeRegion={props.activeRegion}
                        setActiveRegion={props.setActiveRegion}
                    />
                </div>
            )}

            {props.activeRegion.technology === MapTechnology.FIBER && !props.static && (
                <div className="coverage-buttons coverage-buttons-secondary">
                    <p>Vælg fiberleverandør:</p>

                    {props.fiberMapOnly && (
                        <CoverMapChoiceButton
                            mapRegion={ALL_FIBER}
                            activeRegion={props.activeRegion}
                            setActiveRegion={props.setActiveRegion}
                        />
                    )}

                    {Object.entries(FiberCoverMapRegions).map(([key, mapRegion]) => {
                        return (
                            <CoverMapChoiceButton
                                key={key}
                                mapRegion={mapRegion}
                                activeRegion={props.activeRegion}
                                setActiveRegion={props.setActiveRegion}
                            />
                        )
                    })}
                </div>
            )}
        </>
    )
}

function CoverMapChoiceButton(props: {
    mapRegion: MapRegion
    activeRegion: MapRegion,
    setActiveRegion: (region: MapRegion) => void
}) {
    return (
        <button
            className={`coverage-button ${props.mapRegion.technology} ${isSameRegion(props.activeRegion, props.mapRegion) ? 'active' : ''}`}
            onClick={() => props.setActiveRegion(props.mapRegion)}
        >
            {props.mapRegion.display_name}
        </button>
    )
}